import Constants from "./Constants";

const MarketUtil = {

    resolveMarket() {
        const host = window.location.hostname;

        if (host.endsWith('.lu')) {
            return Constants.MARKET().lu;
        }
        return Constants.MARKET().be;
    },


};

export default MarketUtil;
